import classNames from 'classnames/bind';
import styles from './EditDetail.module.css';

import { useAppSelector } from '../../../hooks/useRedux';
import { useSlice } from '../../../hooks/useSlice';
import { selectMenu } from '../../../features/infoSlice';

import ebookCover from '../../../assets/images/book_list_select_mode.svg';
import layeredEbookCover from '../../../assets/images/book_list_select_mode_multiple.svg';
import driveCover from '../../../assets/images/my_drive_select_mode.svg';
import driveLayeredCover from '../../../assets/images/my_drive_select_mode_multiple.svg';
import {
  FILE,
  ITEMS_SELECTED_MESSAGE,
  SELPUB,
  SIZE,
  USED_SIZE,
} from '../../../constants';
import { formatBytes } from '../../../utils/util';
import { Library } from '../../../types/library';
import { isOfType } from '../../../utils/typeGuard';

export default function EditDetail() {
  const cx = classNames.bind(styles);
  const menu = useAppSelector(selectMenu);
  const { selectSelectedIds, selectSelectedItems } = useSlice();

  const selectedIds = useAppSelector(selectSelectedIds);
  const selectedItems = useAppSelector(selectSelectedItems);

  const coverImage =
    menu === 'mydrive' || menu === 'trash'
      ? selectedIds.length > 1
        ? driveLayeredCover
        : driveCover
      : selectedIds.length > 1
      ? layeredEbookCover
      : ebookCover;

  const fileSize = selectedItems.reduce(
    (acc, item) =>
      acc +
      (isOfType(item, 'projectResource')
        ? isOfType(item.projectResource, 'size')
          ? item.projectResource.size
          : item.projectResource.totalSize
        : isOfType(item, 'resource')
        ? item.resource.size
        : 0),
    0
  );
  const selpubUsedSize = selectedItems.reduce(
    (acc, item) =>
      acc +
      (isOfType(item, 'projectResource')
        ? item.projectResource.selpubSize
        : isOfType(item, 'resource')
        ? isOfType(item.resource, 'selpubSize')
          ? item.resource.selpubSize
          : item.resource.size
        : 0),
    0
  );

  return (
    <div className={cx('panel')}>
      <img src={coverImage} alt={FILE} />
      <span
        className={cx('desc')}
        dangerouslySetInnerHTML={{
          __html: ITEMS_SELECTED_MESSAGE.replace(
            '{N}',
            selectedIds.length.toString()
          ),
        }}
      ></span>
      {selectedIds.length > 0 && menu === 'library' && (
        <span className={cx('filesize')}>
          {FILE} {SIZE} :{' '}
          {typeof fileSize === 'string' ? fileSize : formatBytes(fileSize)}
        </span>
      )}

      {selectedIds.length > 0 && (
        <span className={cx('filesize')}>
          {SELPUB} {USED_SIZE} :{' '}
          {typeof selpubUsedSize === 'string'
            ? selpubUsedSize
            : formatBytes(selpubUsedSize)}
        </span>
      )}
    </div>
  );
}
